<template>
  <div>
    <div class="xc-page xc-page-sandwich">
      <div class="xc-page-main">
        <!-- 面包屑 -->
        <div class="xc-breadcrumb">
          <a href>节目管理</a>
          <a href>素材库</a>
        </div>
        <!-- 铺满 -->
        <div class="xc-row xc-s-flex">
          <div class="xc-card">
            <div class="xc-card-content">
              <div class="xc-device-group">
                <div class="xc-device-group-title">分组:</div>
                <div class="xc-device-group-main">
                  <!--<div class="expandBefore expand">
                                        <div
                                            :class="item.checked?'xc-device-group-item-checked': 'xc-device-group-item'"
                                            v-for="(item, index) in expandBeforeGroups"
                                            :key="index"
                                            :data-index="index"
                                            @click="selectGroup($event,item)"
                                        >
                                            {{item.fileGroupName}} ({{item.filetotal}})
                                            <ul v-if="item.fileDefault!='default'">
                                                <li><span @click.stop="mix_action('reName',item,$event)">重命名</span>
                                                </li>
                                                <li><span @click.stop="mix_action('delete',item,$event)">删除</span>
                                                </li>
                                            </ul>
                                        </div>


                                        <div
                                            class="xc-device-group-open"
                                            @click="openGroup"
                                            v-if="closeGroups && expandAfterGroups && expandAfterGroups.length"
                                        >
                                            <span>展开</span>
                                            <img
                                                src="../assets/gy/arrow-up.png"
                                                alt="展开"
                                            >
                                        </div>
                                        <div class="xc-flex-center" style="margin-left: 20px;" v-if="closeGroups">
                                            <button
                                                type="button"
                                                class="xc-btn xc-btn-primary"
                                                @click="modalName = 'volumeSetting'"
                                            >添加分组
                                            </button>
                                        </div>

                                    </div>
                                    <div class="expandAfter expand" v-if="!closeGroups">
                                        <div
                                            :class="item.checked?'xc-device-group-item-checked': 'xc-device-group-item'"
                                            v-for="(item, index) in expandAfterGroups"
                                            :key="index"
                                            :data-index="index"
                                            @click="selectGroup($event,item)"
                                        >
                                            {{item.fileGroupName}} ({{item.filetotal}})
                                            <ul v-if="item.fileDefault!='default'">
                                                <li><span @click.stop="mix_action('reName',item,$event)">重命名</span>
                                                </li>
                                                <li><span @click.stop="mix_action('delete',item,$event)">删除</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            class="xc-device-group-close"
                                            @click="closeGroup"
                                            v-if="!closeGroups"
                                        >
                                            <span>收起</span>
                                            <img
                                                src="../assets/gy/arrow-up.png"
                                                alt="收起"
                                            >
                                        </div>
                                        <div class="xc-flex-center" style="margin-left: 20px;">
                                            <button
                                                type="button"
                                                class="xc-btn xc-btn-primary"
                                                @click="modalName = 'volumeSetting'"
                                            >添加分组
                                            </button>
                                        </div>
                                    </div>-->
                  <div class="expand">
                    <div
                      v-for="(item, index) in expandBeforeGroups"
                      :class="
                        item.checked
                          ? 'xc-device-group-item-checked'
                          : 'xc-device-group-item'
                      "
                      :key="item.fileId"
                      :data-index="index"
                      @click="selectGroup($event, item)"
                    >
                      {{ item.fileGroupName }} ({{ item.filetotal }})
                      <ul v-if="item.fileDefault != 'default'">
                        <li>
                          <span @click.stop="mix_action('reName', item, $event)"
                            >重命名</span
                          >
                        </li>
                        <li>
                          <span @click.stop="mix_action('delete', item, $event)"
                            >删除</span
                          >
                        </li>
                      </ul>
                    </div>

                    <template v-if="!closeGroups">
                      <div
                        :class="
                          item.checked
                            ? 'xc-device-group-item-checked'
                            : 'xc-device-group-item'
                        "
                        v-for="(item, index) in expandAfterGroups"
                        :key="item.fileId"
                        :data-index="index"
                        @click="selectGroup($event, item)"
                      >
                        {{ item.fileGroupName }} ({{ item.filetotal }})
                        <ul v-if="item.fileDefault != 'default'">
                          <li>
                            <span
                              @click.stop="mix_action('reName', item, $event)"
                              >重命名</span
                            >
                          </li>
                          <li>
                            <span
                              @click.stop="mix_action('delete', item, $event)"
                              >删除</span
                            >
                          </li>
                        </ul>
                      </div>
                    </template>
                    <div
                      class="xc-device-group-open"
                      @click="openGroup"
                      v-if="
                        closeGroups &&
                        expandAfterGroups &&
                        expandAfterGroups.length
                      "
                    >
                      <span>展开</span>
                      <img src="../assets/gy/arrow-up.png" alt="展开" />
                    </div>
                    <div
                      class="xc-device-group-close"
                      @click="closeGroup"
                      v-if="!closeGroups"
                    >
                      <span>收起</span>
                      <img src="../assets/gy/arrow-up.png" alt="收起" />
                    </div>
                    <div class="xc-flex-center" style="margin-left: 20px">
                      <button
                        type="button"
                        class="xc-btn xc-btn-primary"
                        @click="modalName = 'volumeSetting'"
                      >
                        添加分组
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="xc-form-inline xc-form-line-reset">
                <div class="xc-device-row-item">
                  <span class="xc-device-row-title">素材类型:</span>
                  <!--<xc-radio :radio-value="materialType" @radio-fun="radioSelectFun"/>-->
                  <template v-if="materialType && materialType.length">
                    <label
                      class="xc-checkbox-wrap"
                      v-for="(item, index) in materialType"
                      :key="index"
                    >
                      <input
                        type="radio"
                        name="fileType"
                        class="xc-radio"
                        :value="item.typeEn"
                        :checked="index == 0"
                        @click="changeType(item.typeEn)"
                      />
                      <span class="xc-checkbox-label">{{ item.typeName }}</span>
                    </label>
                  </template>
                </div>
              </div>

              <div class="xc-form-inline">
                <div class="xc-s-flex">
                  <span class="xc-device-row-title">素材名称</span>
                  <input
                    type="text"
                    name="fileName"
                    v-model="mix_query.fileName"
                    maxlength="255"
                    class="xc-device-input"
                    placeholder="请输入素材名称"
                  />
                  <button
                    type="submit"
                    class="xc-btn xc-btn-primary"
                    @click.prevent="getFiles"
                  >
                    查询
                  </button>
                </div>

                <!-- 表格数据操作 -->
                <div class="xc-btn-group">
                  <!-- <a
                                        class="xc-btn xc-btn-default"
                                        @click="mix_batchAction('delete',$event)"
                                    >移动分组</a>-->
                  <a class="xc-btn xc-btn-default" @click="mix_batchAction"
                    >批量移动分组</a
                  >
                  <a class="xc-btn xc-btn-default" @click="upload()">上传</a>
                </div>
              </div>
              <div class="xc-device-material" v-if="list && list.length">
                <div
                  class="xc-device-material-item"
                  v-for="(item, index) in list"
                  :key="index"
                  :data-index="index"
                  @click="viewMaterial(item)"
                >
                  <div class="xc-device-material-item-content">
                    <img :src="item.fileImageUrl" alt="素材图" />
                    <div class="xc-device-material-name">
                      {{ item.fileName }}
                    </div>

                    <input
                      type="checkbox"
                      class="xc-checkbox myPosition"
                      @click="click($event)"
                      v-model="item.mix_checkbox"
                    />
                  </div>
                  <div
                    class="xc-material-operation"
                    @click.stop="operation(index)"
                    :data-index="index"
                  >
                    <!-- <div class="xc-material-operation-item">
                                          <img src="../assets/gy/arrow-up.png">
                                        </div>-->
                    <div
                      class="xc-material-operation-item xc-material-operation-item-right"
                    >
                      <span>设置</span>
                      <div
                        class="xc-material-group-operation"
                        v-if="index == curMaterial"
                      >
                        <div @click="handle(0, item, $event)">
                          <a>重命名</a>
                        </div>
                        <div @click="handle(1, item, $event)">
                          <a>移动分组</a>
                        </div>
                        <div @click="handle(2, item, $event)">
                          <a>删除</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tips" v-else>暂无数据，请添加</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 固低栏 -->
      <div class="xc-page-footer">
        <xc-pagination
          @change="pageChange"
          :page="mix_page"
          :total="mix_total"
          :size="mix_pageSize"
        />
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 移动分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'moveGroup'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">移动分组</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form
              class="xc-form"
              name="moveGroup"
              style="min-width: 450px"
              data-vv-scope="moveGroup"
            >
              <xc-form-item
                label="选择分组："
                required
                :error="errors.first('fileGroupId', 'moveGroup')"
              >
                <input
                  type="hidden"
                  name="fileIds"
                  v-model="currentMaterial.fileId"
                />
                <select
                  class="xc-select"
                  name="fileGroupId"
                  v-model="currentMaterial.groupId"
                  v-validate="'required'"
                  data-vv-as="分组"
                  :class="{
                    'xc-input-error': errors.first('fileGroupId', 'moveGroup'),
                  }"
                >
                  <option value="">请选择</option>
                  <template v-if="groupValue && groupValue.length">
                    <option
                      v-for="(item, index) in groupValue"
                      :key="index"
                      :value="item.fileGroupId"
                    >
                      {{ item.fileGroupName }}
                    </option>
                  </template>
                </select>
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="moveGroupSubmit">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 批量移动分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'batchMoveGroup'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">批量移动分组</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form
              class="xc-form"
              name="batchMoveGroup"
              style="min-width: 450px"
              data-vv-scope="moveGroup"
            >
              <xc-form-item
                label="选择分组："
                required
                :error="errors.first('fileGroupId', 'batchMoveGroup')"
              >
                <select
                  class="xc-select"
                  name="fileGroupId"
                  v-validate="'required'"
                  data-vv-as="分组"
                  :class="{
                    'xc-input-error': errors.first(
                      'fileGroupId',
                      'batchMoveGroup'
                    ),
                  }"
                >
                  <option value="">请选择</option>
                  <template v-if="groupValue && groupValue.length">
                    <option
                      v-for="(item, index) in groupValue"
                      :key="index"
                      :value="item.fileGroupId"
                    >
                      {{ item.fileGroupName }}
                    </option>
                  </template>
                </select>
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="batchMoveGroupSubmit">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'volumeSetting'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">添加分组</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form
              class="xc-form"
              style="min-width: 450px"
              name="add"
              data-vv-scope="add"
            >
              <xc-form-item
                required
                label="分组名"
                :error="errors.first('groupName', 'add')"
              >
                <input
                  v-validate="'required|max:6'"
                  data-vv-as="分组名"
                  name="groupName"
                  type="text"
                  maxlength="255"
                  class="xc-input"
                  placeholder="请输入分组名称"
                  :class="{
                    'xc-input-error': errors.first('groupName', 'add'),
                  }"
                />
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="addSumit">确定</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 素材重命名 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'resetName'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">素材重命名</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form
              class="xc-form"
              name="resetName"
              style="min-width: 450px"
              data-vv-scope="resetName"
            >
              <xc-form-item
                label="素材名"
                required
                :error="errors.first('fileName', 'resetName')"
              >
                <input
                  v-validate="'required'"
                  data-vv-as="素材名"
                  name="fileName"
                  v-model="currentMaterial.fileName"
                  type="text"
                  maxlength="255"
                  class="xc-input"
                  placeholder="请输入素材名"
                  :class="{
                    'xc-input-error': errors.first('fileName', 'resetName'),
                  }"
                />
                <input
                  type="hidden"
                  name="fileId"
                  v-model="currentMaterial.fileId"
                />
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="resetSubmit">确定</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 分组重命名 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'resetGroupName'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">分组重命名</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <form
              class="xc-form"
              style="min-width: 450px"
              name="resetGroupName"
              data-vv-scope="resetGroupName"
            >
              <xc-form-item
                label="组名"
                required
                :error="errors.first('fileGroupName', 'resetGroupName')"
              >
                <input
                  type="hidden"
                  name="fileGroupId"
                  v-model="currentGroup.fileGroupId"
                />
                <input
                  v-validate="'required|max:6'"
                  data-vv-as="组名"
                  name="fileGroupName"
                  v-model="currentGroup.fileGroupName"
                  type="text"
                  maxlength="255"
                  class="xc-input"
                  placeholder="请输入新组名"
                />
              </xc-form-item>
            </form>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="resetGroupSubmit">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 删除 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'deleteMaterial'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">删除素材</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <div class="xc-device-tipText">确定要删除该素材？</div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="deleteMaterialSubmit">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 删除分组 -->
    <div class="xc-modal xc-modal-dialog" v-if="modalName == 'deleteGroup'">
      <div class="xc-modal-mask" @click="modalName = null"></div>
      <div class="xc-modal-wrap xc-anim-scaleIn">
        <div class="xc-modal-content">
          <div class="xc-modal-header">
            <div class="xc-modal-title">删除分组</div>
            <div class="xc-modal-close" @click="modalName = null"></div>
          </div>
          <div class="xc-modal-body xc-flex-center">
            <div class="xc-device-tipText">确定要删除该分组？</div>
          </div>
          <div class="xc-modal-footer xc-flex-center">
            <div class="xc-btn-group">
              <div class="xc-btn xc-btn-default" @click="modalName = null">
                取消
              </div>
              <div class="xc-btn xc-btn-primary" @click="deleteGroupSubmit">
                确定
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import mixin from "../xc-ui/mixins/list";
// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";
// 弹层
import myLayerImport from "@/libs/myLayer";
//接口
import material from "@/api/material";

function close(e) {
  e.stopPropagation();
  var operation = "xc-material-operation";
  if (e && e.path) {
    for (let i = 0; i < e.path.length; i++) {
      const item = e.path[i].className;
      /* if (item.className && item.className.indexOf('xc-btn-select') != -1) {
                 return;
             }*/
      if (item == operation) {
        return;
      }
    }
  }

  this.close();
}

export default {
  name: "DeviceList",
  data() {
    return {
      // 列表key
      mix_listKey: "list",

      // 列表唯一字段
      mix_listId: "fileId",

      list: [],

      // 默认查询参数
      mix_query: {
        fileGroupId: "",
        fileName: "",
        fileType: "",
      },

      closeGroups: true,

      // 分组
      groupValue: [],

      // 增播素材
      materialValue: [],

      // 弹出窗
      modalName: null,

      // 素材类型
      materialType: [],
      //  当前分组
      currentGroup: {},
      //  当前素材
      currentMaterial: {},

      //  控制下拉按钮的显示
      curMaterial: -1,

      adminPath: this.$config.adminPath,

      fileGroupIdCope: "",
    };
  },

  computed: {
    expandBeforeGroups() {
      return this.groupValue.slice(0, 8);
    },
    expandAfterGroups() {
      return this.groupValue.slice(8);
    },
  },
  watch: {},
  async created() {
    var _this = this;
    // 加载JS
    await myLayerImport();

    //    请求素材类型
    await material
      .getAllFileType()
      .then(function (success) {
        _this.materialType = success.data;
        //默认素材类型未第一个分类
        _this.mix_query.fileType = success.data[0].typeEn;
      })
      .catch(function (error) {
        console.log(error);
      });

    //    获取素材分组
    //     获取素材列表
    _this
      .getFileGroup({ fileType: _this.mix_query.fileType })
      .then(function (res) {
        _this.getFiles();
      })
      .catch(function (res) {
        console.log(res);
      });
    //    添加监听器
    document.addEventListener("click", close.bind(_this));
  },

  methods: {
    //  获取素材分组
    async getFileGroup() {
      var _this = this;
      var result = false;
      //    请求分组列表
      await material
        .getFileGroup({ fileType: _this.mix_query.fileType })
        .then(function (success) {
          success.data.forEach(function (item, index) {
            if (_this.fileGroupIdCope) {
              if (item.fileGroupId == _this.fileGroupIdCope) {
                item.checked = true;
              } else {
                item.checked = false;
              }
            } else {
              //设置第一个分组选中
              if (index == 0) {
                item.checked = false;
              } else {
                item.checked = false;
              }
            }
          });
          // 更新分组
          _this.groupValue = success.data;
          //更新查询条件
          _this.mix_query.fileGroupId = _this.fileGroupIdCope;
          result = true;
        })
        .catch(function (error) {
          console.log(error);
        });
      if (result) {
        return Promise.resolve("成功");
      } else {
        return Promise.reject("失败");
      }
    },

    //  素材类型发生变化
    changeType: function (fileType) {
      this.mix_query.fileType = fileType;
      this.mix_query.fileName = "";
      this.mix_page = 1;
      this.getFileGroup();
      this.getFiles();
    },

    //  获取素材列表
    getFiles() {
      var _this = this;
      // 默认搜索的数据
      const search = {
        pageNum: this.mix_page,
        pageSize: this.mix_pageSize,
        ...this.mix_query,
      };

      material
        .getFileByPage(search)
        .then(function (ret) {
          _this.list = _this.mix_format(ret.data.list);
          _this.mix_total = ret.data.total;
          _this.mix_page = ret.data.pageNum;
          _this.mix_pageSize = ret.data.pageSize;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //  选择素材
    click: function (e) {
      e.stopPropagation();
    },

    //  添加素材分组
    addSumit: function () {
      var _this = this;
      var myForm = document.add;
      // 验证器命名空间
      const scope = "add";

      this.$validator
        .validateAll(scope)
        .then((validate) => {
          if (validate) {
            return this.$formFormat(myForm);
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then((formData) => {
          console.log("formData", formData);
          if (formData) {
            material
              .addFileGroup(formData)
              .then(function (success) {
                // _this.$message.success(success.msg);
                _this.$message.success("分组增加成功");
                _this.modalName = null;
                _this
                  .getFileGroup()
                  .then(function (res) {
                    _this.getFiles();
                  })
                  .catch(function (res) {
                    console.log(res);
                  });
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        });
    },
    //  素材分组重命名
    resetGroupSubmit: function () {
      var _this = this;
      // 验证器命名空间
      const scope = "resetGroupName";

      this.$validator
        .validateAll(scope)
        .then((validate) => {
          if (validate) {
            return this.currentGroup;
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then((formData) => {
          if (formData) {
            material.editFileGroup(formData).then(function (success) {
              _this.$message.success("重命名成功");
              _this.modalName = null;
              _this.getFileGroup().then(function (res) {
                // _this.getFiles();
              });
            });
          }
        });
    },
    // 删除分组
    deleteGroupSubmit() {
      material
        .deletebyFileGroupIds({
          fileGroupIds: this.currentGroup.fileGroupId,
        })
        .then((success) => {
          this.$message.success("分组删除成功");
          this.modalName = null;
          this.getFileGroup().then((res) => {
            this.getFiles();

            // 删除以后验证一次展开按钮
            if (this.expandAfterGroups && this.expandAfterGroups.length == 0) {
              this.closeGroups = true;
            }
          });
        });
    },

    // 操作分组
    action(...args) {
      const [action, item, index] = args;
      const e = args[args.length - 1];
      this.currentGroup = { ...item };
      switch (action) {
        case "reName":
          this.modalName = "resetGroupName";
          break;
        case "delete":
          //打开弹窗
          this.modalName = "deleteGroup";
          break;
        default:
          break;
      }
    },
    //  批量操作
    batchAction: function () {
      //    批量移动分组
      this.modalName = "batchMoveGroup";
    },
    //  批量移动分组确定
    batchMoveGroupSubmit: function () {
      var _this = this;
      var myForm = document.batchMoveGroup;
      // 验证器命名空间
      const scope = "batchMoveGroup";
      this.$validator
        .validateAll(scope)
        .then((validate) => {
          if (validate) {
            return this.$formFormat(myForm);
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then((formData) => {
          if (formData) {
            var obj = {};
            obj.fileGroupId = formData.fileGroupId;
            var checked = _this.mix_checkedList;
            var arr = [];
            checked.forEach(function (value) {
              arr.push(value.fileId);
            });
            obj.fileIds = arr.join(",");
            material.updateFileGroupById(obj).then(function (success) {
              _this.$message.success("批量移动分组成功");
              _this.modalName = null;
              _this.getFileGroup().then(function (res) {
                _this.getFiles();
              });
            });
          }
        });
    },

    //  操作素材
    handle: function (type, item, e) {
      e.stopPropagation();
      this.close();
      //    type:0表示重命名，1表示移动分组，2表示删除
      this.currentMaterial = { ...item };
      switch (type) {
        case 0:
          this.modalName = "resetName";
          break;
        case 1:
          this.modalName = "moveGroup";
          break;
        case 2:
          this.modalName = "deleteMaterial";
          break;
        default:
          break;
      }
    },
    //  素材重命名
    resetSubmit: function () {
      var _this = this;
      // 验证器命名空间
      const scope = "resetName";

      this.$validator
        .validateAll(scope)
        .then((validate) => {
          if (validate) {
            return this.currentMaterial;
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then((formData) => {
          if (formData) {
            material
              .updateFileNameById(formData)
              .then(function (success) {
                _this.$message.success("操作成功");
                _this.modalName = null;
                _this.getFiles();
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        });
    },
    //  素材移动分组
    moveGroupSubmit: function () {
      var _this = this;
      // 验证器命名空间
      const scope = "moveGroup";
      var myForm = document.moveGroup;

      this.$validator
        .validateAll(scope)
        .then((validate) => {
          if (validate) {
            return this.$formFormat(myForm);
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then((formData) => {
          if (formData) {
            material.updateFileGroupById(formData).then(function (success) {
              _this.$message.success("移动分组成功");
              _this.modalName = null;
              _this.getFileGroup().then(function (res) {
                _this.getFiles();
              });
            });
          }
        });
    },
    //  删除素材
    deleteMaterialSubmit: function () {
      var _this = this;
      var obj = {
        fileId: _this.currentMaterial.fileId,
      };
      material.deleteFileById(obj).then(function (success) {
        _this.$message.success("删除成功");
        _this.modalName = null;
        _this.getFileGroup().then(function (res) {
          _this.getFiles();
        });
      });
    },
    //  素材预览
    viewMaterial(item) {
      var _this = this;
      myLayer.open({
        type: 2,
        title: false,
        shadeClose: true,
        closeBtn: 0, //不显示关闭按钮
        area: ["981px", "550px"],
        // content: '/example/layer/page',
        content:
          _this.adminPath +
          "/material/preview?name=" +
          item.fileName +
          "&type=" +
          item.fileType +
          "&url=" +
          item.url,
        success: function (layero, index) {},
      });
    },

    // 操作素材按钮
    operation(index) {
      this.curMaterial = index;
    },
    //打开操作项
    close() {
      this.curMaterial = -1;
    },
    // 上传弹层方法
    layer(options) {
      layer.open({
        type: 2,
        title: false,
        closeBtn: 0,
        area: ["672px", "379px"],
        shadeClose: true,
        ...options,
      });
    },

    upload() {
      var _this = this;
      var type = this.mix_query.fileType;
      switch (type) {
        case "image":
          this.layer({
            content:
              this.adminPath +
              "/material/upload/image?channel=1&fileGroupId=" +
              this.mix_query.fileGroupId,
            success: function () {
              window.imageUploadSubmit = (data) => {
                _this.$message.success("上传成功");
                _this
                  .getFileGroup()
                  .then(function (res) {
                    _this.getFiles();
                  })
                  .catch(function (res) {
                    console.log(res);
                  });
              };
            },
          });
          break;
        case "video":
          this.layer({
            content:
              this.adminPath +
              "/material/upload/video?channel=1&fileGroupId=" +
              this.mix_query.fileGroupId,
            success: function () {
              window.videoUploadSubmit = (data) => {
                _this.$message.success("上传成功");
                _this
                  .getFileGroup()
                  .then(function (res) {
                    _this.getFiles();
                  })
                  .catch(function (res) {
                    console.log(res);
                  });
              };
            },
          });
          break;
        case "web":
          this.layer({
            area: ["976px", "550px"],
            content:
              this.adminPath +
              "/material/upload/web?channel=1&fileGroupId=" +
              this.mix_query.fileGroupId,
            success: function () {
              window.webUploadSubmit = (data) => {
                _this.$message.success("上传成功");
                _this
                  .getFileGroup()
                  .then(function (res) {
                    _this.getFiles();
                  })
                  .catch(function (res) {
                    console.log(res);
                  });
              };
            },
          });
          break;
        default:
          break;
      }
    },

    // 初始化数据
    initData() {},
    //  分页
    pageChange: function (page, pageSize) {
      this.mix_page = page;
      this.mix_pageSize = pageSize;

      // this.mix_setUrlQuery();

      this.getFiles();
    },

    // 收起组名
    closeGroup() {
      this.closeGroups = true;
    },

    // 展开组名
    openGroup() {
      if (this.expandAfterGroups.length == 0) {
        this.$message.warning("没有更多了");
        return;
      }
      this.closeGroups = false;
    },

    // 选择组名
    selectGroup(e, obj) {
      for (let item of this.groupValue) {
        item.checked = false;
      }
      obj.checked = true;
      this.fileGroupIdCope = obj.fileGroupId;
      this.mix_query.fileGroupId = obj.fileGroupId;
      this.mix_query.fileName = "";
      this.getFiles();
    },
  },

  mixins: [mixin],
};
</script>

<style scoped lang="scss">
.xc-device-group {
  display: flex;
}

.xc-device-group-title {
  width: 40px;
  line-height: 1;
  margin-top: 12px;
}

.xc-device-group-main {
  flex: 1;

  .expand {
    display: flex;
    flex-wrap: wrap;
  }
}

.xc-form-line-reset {
  height: 20px;
  margin-bottom: 30px;
}

.xc-device-group-close,
.xc-device-group-open {
  display: flex;
  align-items: center;
  color: #507dde;
  margin-left: 20px;
  cursor: pointer;
}

.xc-device-group-close span,
.xc-device-group-open span {
  margin-right: 2px;
}

.xc-device-group-close img,
.xc-device-group-open img {
  width: 9px;
  height: 6px;
}

.xc-device-group-open img {
  transform: rotate(180deg);
}

.xc-device-group-item {
  padding: 5px 12px;
  line-height: 14px;
  font-size: 14px;
  color: #6e7a90;
  margin: 7px 0;
  cursor: pointer;
  position: relative;

  &:hover {
    ul {
      display: flex;
    }

    color: rgba(80, 125, 222, 0.5);
  }
}

ul {
  position: absolute;
  top: 90%;
  left: 0;
  display: none;
  background: rgba(0, 0, 0, 0.6);
  width: 143px;
  padding-left: 4px;
  border-radius: 8px;
  margin-top: 0;
  z-index: 1;

  &:after {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-color: rgba(0, 0, 0, 0.6);
    content: "";
    position: absolute;
    top: -10px;
    left: 30px;
  }

  li {
    line-height: 28px;
    color: #cfd5e0;
    flex: 1;
    text-align: center;
    position: relative;

    span {
      font-size: 12px;
      display: inline-block;
    }

    &:nth-child(1) {
      &:after {
        content: "";
        background: #ffffff;
        width: 0.05rem;
        height: 15px;
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -1px;
        transform: translateY(-50%);
      }
    }
  }
}

.xc-device-group-item-checked {
  padding: 5px 12px;
  line-height: 14px;
  font-size: 14px;
  color: #fff;
  background: rgba(80, 125, 222, 0.5);
  border-radius: 8px;
  margin: 7px 0;
  cursor: pointer;
  position: relative;

  &:hover {
    ul {
      display: flex;
    }
  }
}

.xc-device-material {
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
}

.xc-device-material-item {
  width: 20%;
  padding-top: calc(20% * 0.57);
  /*min-width: 251px;*/
  min-height: 144px;
  position: relative;

  /*background: #eeeeee;*/
  .xc-device-material-item-content {
    position: absolute;
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    top: 0;
    left: 0;
    background: #eff2f8;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      // border-radius: 6px;
      height: 100%;
      // object-fit: contain;
    }
  }
}

.xc-device-material-name {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 21px;
  background-color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: white;
  font-size: 12px;
  border-radius: 0 0 6px 6px;
}

// .xc-device-material-item:nth-child(6n),
// .xc-device-material-item-checked:nth-child(6n) {
//   margin-right: 0;
// }

.xc-device-row-item {
  display: flex;
  align-items: center;
}

.xc-device-row-title {
  margin-right: 8px;
}

.xc-device-input {
  flex: 1;
  width: 220px;
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #cfd5e0;
  color: #808b9e;
  font-size: inherit;
  margin-right: 14px;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #cfd5e0;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #cfd5e0;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #cfd5e0;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cfd5e0;
}

.xc-device-tipText {
  font-size: 18px;
  color: #6e7a90;
}

.xc-material-operation {
  display: flex;
  width: 40px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.59);
  border-radius: 6px;
  position: absolute;
  right: 28px;
  top: 8px;
  color: #cfd5e0;
}

.xc-material-operation-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  font-size: 12px;
}

.xc-material-operation-item:first-child {
  position: relative;
}

// .xc-material-operation-item:first-child::after {
//   content: '';
//   height: 100%;
//   width: 1px;
//   background: rgba(255, 255, 255, 0.38);
//   position: absolute;
//   top: 50%;
//   right: 0;
//   transform: translateY(-50%)
// }

.xc-material-operation-item img {
  width: 12px;
  height: 12px;
}

.xc-material-group-operation {
  width: 120px;
  height: 90px;
  background: #fff;
  border: solid 1px #cfd5e0;
  border-radius: 8px;
  position: absolute;
  bottom: -98px;
  right: -35px;
  z-index: 100;
  font-size: 14px;
}

.xc-material-group-operation::after {
  content: "";
  width: 0;
  height: 0;
  border-width: 0 8px 8px;
  border-style: solid;
  border-color: transparent transparent #fff;
  position: absolute;
  top: -8px;
  right: 46px;
}

.xc-material-group-operation div {
  height: 30px;
  color: #727e93;
  text-align: center;
  line-height: 30px;
  font-size: 13px;
}

.xc-material-group-operation div:hover {
  background: rgba(80, 125, 222, 0.2);
  color: #727e93;
}

.xc-material-operation-item-right {
  position: relative;
}

.xc-material-checked-box {
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #cfd5e0;
  position: absolute;
  top: 9px;
  left: 9px;
}

.myPosition {
  position: absolute;
  top: 9px;
  left: 9px;
}

.xc-material-checked-box-choose {
  width: 16px;
  height: 16px;
  background-color: #507dde;
  border-radius: 4px;
  border: solid 1px #cfd5e0;
  position: absolute;
  top: 9px;
  left: 9px;
}

.xc-material-checked-box-choose::after {
  content: "";
  width: 6px;
  height: 10px;
  border-color: #fff;
  border-style: solid;
  border-width: 0 2px 2px 0;
  border-radius: 2px;
  transform: rotate(45deg);
  position: absolute;
  top: 0px;
  right: 4px;
  z-index: 11;
}
</style>
